export default __webpack_public_path__ + "static/media/step1.4d9d545e.PNG";